import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

export const SolutionCustomer = () => {
  const { t } = useTranslation();
  const logoList = [
    {
      imgurl: "//files.authing.co/authing-website/brand-state-grid.png",
      alt: `authing ${t("common.logo.国家电网")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-cnpc-new.png",
      alt: `authing ${t("common.logo.中国石油")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-dongnan-new.png",
      alt: `authing ${t("common.logo.东南大学")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-higer-new.png",
      alt: `authing ${t("common.logo.高等教育出版社")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/brand-logo-zhaoshang.svg",
      alt: `authing ${t("common.logo.招商银行")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-dazhong-new.png",
      alt: `authing ${t("common.logo.丰田")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/brand-toyota-red.svg",
      alt: `authing ${t("common.logo.丰田")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-bentley.png",
      alt: `authing ${t("common.logo.宾利")}`,
    },

    {
      imgurl: "//files.authing.co/authing-website/home-logo-honor.svg",
      alt: `authing honor`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-bosch.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-pingcap.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/brand-logo-jcdecaux.png",
      alt: `authing ${t("common.logo.德高集团")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-yuanqi.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-tetin-new.png",
      alt: `authing ${t("common.logo.云测")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-kingdee-new.png",
      alt: `authing ${t("common.logo.金蝶")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-stack-new.png",
      alt: `authing ${t("common.logo.stackchat")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-deephow.png",
      alt: `authing`,
    },

    {
      imgurl: "//files.authing.co/authing-website/home-logo-aws-new.png",
      alt: `authing ${t("common.logo.亚马逊")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/brand-bentley.png",
      alt: `authing ${t("common.logo.宾利")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/brand-theragun.svg",
      alt: `authing ${t("common.logo.THERAGUN")}`,
    },

    // { imgurl: "//files.authing.co/authing-website/home-logo-cnpc-new.png" },
    // // { imgurl: "//files.authing.co/authing-website/logo-baai-new.png" },
    // { imgurl: "//files.authing.co/authing-website/home-logo-higer-new.png" },
    // { imgurl: "//files.authing.co/authing-website/home-logo-tetin-new.png" },
    // { imgurl: "//files.authing.co/authing-website/home-logo-dongnan-new.png" },
    // { imgurl: "//files.authing.co/authing-website/home-logo-pand-new.png" },
    // { imgurl: "//files.authing.co/authing-website/home-logo-stack-new.png" },
    // { imgurl: "//files.authing.co/authing-website/home-logo-chatopera-new.png" },

    // { imgurl: "//files.authing.co/authing-website/home-logo-tencent-new.png" },

    // { imgurl: "//files.authing.co/authing-website/home-logo-aws-new.png" },

    // { imgurl: "//files.authing.co/authing-website/home-logo-lezhi-new.png" },

    // { imgurl: "//files.authing.co/authing-website/home-logo-memect-new.png" },

    // { imgurl: "//files.authing.co/authing-website/home-logo-kingdee-new.png" },

    // { imgurl: "//files.authing.co/authing-website/home-logo-free-new.png" },

    // { imgurl: "//files.authing.co/authing-website/home-logo-aliyun-new.png" },
    // { imgurl: "//files.authing.co/authing-website/home-logo-juzi-new.png" },

    // { imgurl: "//files.authing.co/authing-website/home-logo-huawei-new.png" },

    // { imgurl: "//files.authing.co/authing-website/home-logo-jinzheng-new.png" },
    // { imgurl: "//files.authing.co/authing-website/home-logo-unity-new.png" },
  ];
  return (
    <section>
      <div className="solution-customer">
        <div className="inner">
          {/* <div className="top">
            <div className="title">{t("solution.list.customer.title")}</div>
          </div> */}
          <Title title={t("solution.list.customer.title")}></Title>
          <div className="card-warp">
            {logoList.map((item) => {
              return (
                <div className="card">
                  <img src={item.imgurl} alt={item.alt} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
